import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iniziative-divulgative',
  templateUrl: './iniziative-divulgative.component.html',
  styleUrls: ['./iniziative-divulgative.component.css']
})
export class IniziativeDivulgativeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
